import { Box, CircularProgress } from "@mui/material";
import { loadingSx } from "./reportResultStyles";

interface IReportResultLoadingProps {
  message: string;
}

const ReportResultLoading: React.FC<IReportResultLoadingProps> = ({
  message,
}) => (
  <Box sx={loadingSx}>
    <CircularProgress size={24} />
    <span>{message}</span>
  </Box>
);

export default ReportResultLoading;
